import { NuvoImporterQuery } from 'generated/resources/graphql'
import { ColumnType } from 'nuvo-react'
import { ValidatorAPI } from 'nuvo-react'

interface UseColumnsMappingProps {
  data?: NuvoImporterQuery
}

type DropdownOption = {
  label: string
  alternativeMatches?: string[]
  description?: string
  type: string
  value: string
}

type Column = {
  label: string
  key: string
  description?: string
  example?: string | null
  columnSize?: number | null
  validations?: ValidatorAPI[] | null
  columnType?: ColumnType | null
  dropdownOptions?: DropdownOption[] | null
  alternativeMatches?: string[]
  isMultiSelect?: boolean
  outputFormat?: string | null
  allowCustomOptions?: boolean
  numberFormat?: 'eu' | 'us'
  optionMappingMode?: 'smart' | 'exact'
  hidden?: boolean
  disabled?: boolean
}

export const useColumnsMapping = ({ data }: UseColumnsMappingProps) => {
  const columns: Column[] =
    data?.universalImporter.schemaAdaptersConnection.nodes.map(
      ({ __typename, dropdownOptions, validations, ...nuvoField }) => {
        const mappedValidations: ValidatorAPI[] =
          validations?.map(({ __typename: _validationTypename, ...nuvoValidation }) => ({
            ...nuvoValidation,
            errorMessage: nuvoValidation.errorMessage || '',
          })) || []
        const mappedDropdownOptions =
          dropdownOptions?.map(({ __typename: __dropdownOptionTypename, ...option }) => ({
            ...option,
          })) || []

        return {
          ...nuvoField,
          dropdownOptions: mappedDropdownOptions,
          validations: mappedValidations,
          isMultiSelect: nuvoField.isMultiSelect == true,
        }
      }
    ) || []

  return { columns }
}
